/**
 * initAdminFormControls — 관리자 폼 컨트롤 일괄 초기화 (스코프 단위).
 *
 * 페이지(AdminLayout.init)와 동적 주입 모달(예: 캘린더 게시글 폼)이 **동일한 폼 컨트롤
 * 초기화 세트**를 공유하도록 한 곳에 모은다. 모달은 AdminLayout.init 이후 주입되므로
 * 이 함수를 모달 본문 스코프로 호출해야 탭·에디터·업로더 등이 작동한다.
 *
 * 주의: `initAdminForms`(= [data-admin-ajax] 폼 submit 바인딩)는 포함하지 않는다 —
 * 모달은 자체 `new Form(...)` 으로 submit 을 처리하므로 이중 바인딩을 피한다.
 */
import {
    initAdminDateTimeInputs,
    initAdminFlatpickrPickers,
    initAdminSelects,
    initTagInputs,
    initNumberSteppers,
    initCharCounters,
} from "./AdminForm";
import { initAdminEntityPicker } from "./AdminEntityPicker";
import { initFileUploaders } from "../components/FileUploader";
import { LocaleTabs } from "../components/LocaleTabs";
import { RichEditor } from "../../components/RichEditor";
import { CodeEditor } from "../../components/CodeEditor";
import { initCmsItemForm } from "../components/CmsMenuItemForm";
import { initCmsSectionForm } from "../components/CmsSectionForm";
import { initCmsJsonRepeaters } from "../components/CmsJsonRepeater";
import { initCmsHtmlPreviews } from "../components/CmsHtmlPreview";
import { initCmsTemplateLazyPreviews } from "../components/CmsTemplatePicker";
import { initCmsTemplateRepeats } from "../components/CmsTemplateRepeat";
import { initFigmaColorFields } from "../components/FigmaColorField";

export function initAdminFormControls(scope: Document | HTMLElement = document): void {
    // 스코프 미지원(전역 스캔) — 각자 멱등 가드가 있어 모달 주입분만 새로 init 된다.
    initAdminDateTimeInputs();
    initAdminFlatpickrPickers();
    initFileUploaders();

    // 스코프 지원 — 주입된 모달 본문만 대상으로 init.
    initAdminSelects(scope);
    initTagInputs(scope);
    initNumberSteppers(scope);
    initCharCounters(scope);
    initFigmaColorFields(scope);
    initAdminEntityPicker(scope);
    LocaleTabs.initAll(scope);
    RichEditor.initAll(scope);
    CodeEditor.initAll(scope);
    initCmsItemForm(scope);
    initCmsSectionForm(scope);
    initCmsJsonRepeaters(scope);
    initCmsHtmlPreviews(scope);
    initCmsTemplateLazyPreviews(scope);
    initCmsTemplateRepeats(scope);
}
